import "../../../assets/css/Variables.css";
import React from "react";

export default function LikeIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="32"
      height="32"
      viewBox="0 0 32 32"
    >
      <g
        id="Group_27763"
        data-name="Group 27763"
        transform="translate(-346 -94)"
      >
        <path
          id="Path_16063"
          data-name="Path 16063"
          d="M0,0H32V32H0Z"
          transform="translate(346 94)"
          fill="rgba(255,0,0,0.53)"
          opacity="0"
        />
        <path
          id="Path_18539"
          data-name="Path 18539"
          d="M20.811,3c3.941,0,7.135,3.243,7.135,7.784,0,9.081-9.73,14.27-12.973,16.216C11.73,25.054,2,19.865,2,10.784,2,6.243,5.243,3,9.135,3a8.584,8.584,0,0,1,5.838,2.595A8.584,8.584,0,0,1,20.811,3Z"
          transform="translate(347 95)"
          fill="#9d2d20"
        />
      </g>
    </svg>
  );
}
